import {Injector} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {Keyboard} from '@capacitor/keyboard';
import {PageController} from './page-controller';

export abstract class ModalPageController extends PageController {

  keyboardDidShowListener?: any;
  keyboardDidHideListener?: any;

  keyboardVisible: boolean = false;

  protected constructor(
    protected override injector: Injector
  ) {
    super(injector);

    this.initKeyboardEvents();
  }


  /**
   * Inicializar los eventos del teclado
   *
   */
  async initKeyboardEvents() {

    if (!Capacitor.isNativePlatform()) {
      return;
    }

    this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', () => {
      this.keyboardVisible = true;
    });

    this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', () => {
      this.keyboardVisible = false;
    });
  }


  /**
   * Comprobar si el teclado está abierto al cerrar el modal
   *
   */
  dismiss(result: any = null, role: string = '') {

    if (!this.keyboardVisible) {
      this.dismissModal(result, role);
      return;
    }

    setTimeout(() => this.dismissModal(result, role), 150);
  }


  /**
   * Cerrar modal y eliminar los eventos de teclado
   *
   */
  dismissModal(result: any = null, role: string = '') {

    if (Capacitor.isNativePlatform()) {
      this.keyboardRemoveAllListeners();
    }

    this.modalCtrl.dismiss(result, role);
  }


  /**
   * Eliminar todos los eventos del teclado
   *
   */
  keyboardRemoveAllListeners() {

    if (this.keyboardDidShowListener) {
      this.keyboardDidShowListener.remove();
    }

    if (this.keyboardDidHideListener) {
      this.keyboardDidHideListener.remove();
    }
  }

}
